<div class="form-group mb-0">
  <div
    #panel
    class="panel-upload"
    [class.success]="selectedFile && !warning && !isDragged"
    [class.warning]="warning && !isDragged"
    [class.dragged]="isDragged"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()">
    <div class="vertical-center">
      <ng-container *ngIf="!isDragged">
        <ng-container *ngIf="!warning">
          <ng-container *ngIf="!selectedFile">
            <yat-icon id="542e4ac8-3c98-4011-8b94-610e0bc6741a" name="cloud-upload" title="Upload"></yat-icon>
            <p class="c-gray my-2 cloud-upload-label" yat-link>
              <transloco
                id="b74ef6ee-d0d6-4d60-a86d-9842a773bab6"
                key="uiTools.fileSelect.fileSelect.dragAndDropHereOrSelectFile"
                [params]="{ selectFileLink }"></transloco>
            </p>
          </ng-container>
          <ng-container *ngIf="selectedFile">
            <yat-icon id="59d852a9-2ef1-419a-8b43-e1a32a63b19c" name="tick-circle-duo" title="File selected"></yat-icon>
            <p class="coloredText mt-2 mb-0">File selected</p>
            <p class="c-gray mt-0 mb-0">
              {{ selectedFile.name }}
            </p>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="warning">
          <yat-icon id="1cb1f068-9c47-4d67-a1ae-a2a92927bcfa" name="warning-duo" title="Warning"></yat-icon>
          <p class="coloredText my-2" [ngSwitch]="warning">
            <span *ngSwitchCase="'wrongFileType'"
              ><ng-container *ngIf="fileTypes"> Select a {{ fileTypes | describeFileExtension: 'comma-or' }} file. </ng-container></span
            >
            <span *ngSwitchCase="'maxFileSizeExceeded'"> Select a file up to {{ maxFileSize }} MB. </span>
          </p>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isDragged">
        <yat-icon id="bcf0cfe0-9974-4e1d-9b5f-12cd9644316f" name="cloud-upload" title="Upload"></yat-icon>
        <p class="c-gray font my-2">Drop file to upload.</p>
      </ng-container>
    </div>
    <p class="bottom c-gray" [ngClass]="{ filename: selectedFile && !isDragged }">
      <ng-container *ngIf="!isDragged && (warning || selectedFile)">
        <a yat-link class="link link-primary link-large" [routerLink]="null" (blur)="onTouched()"> Select new </a>
      </ng-container>
      <ng-container *ngIf="(!selectedFile && !warning) || isDragged">
        <ng-container *ngIf="fileTypes">{{ fileTypes | describeFileExtension: 'dot' }} | </ng-container>max {{ maxFileSize }} MB
        <ng-container *ngIf="additionalFileInfo"> | {{ additionalFileInfo }} </ng-container></ng-container
      >
    </p>
  </div>
  <input
    #fileInput
    type="file"
    hidden
    [accept]="fileExtensions === null ? '*' : (fileExtensions | describeFileExtension: 'input-accept')"
    (change)="selectFileFromEventTarget($event.target)" />
</div>
